var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"axis"},[_c('span',{staticClass:"title",attrs:{"id":_vm.$attrs.elementId}},[_vm._v(_vm._s(_setup.props.title))]),_c('a-input',{staticClass:"axis_input",attrs:{"value":_setup.props.content},on:{"change":_setup.handleChangeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }